import { css } from '@emotion/css';

import { largeDesktopMediaQuery } from '../../constants';

export const defaultStickerInsetPx = -16;

export const stickerCss = css`
  height: auto;
  pointer-events: none;
  position: absolute;
  width: 60px;

  ${largeDesktopMediaQuery} {
    width: 80px;
  }
`;

export const stickerImgCss = css`
  object-fit: contain;
  width: 100%;
`;

export const stickerMediumCss = css`
  width: 80px;

  ${largeDesktopMediaQuery} {
    width: 110px;
  }
`;

export const stickerLargeCss = css`
  width: 80px;

  ${largeDesktopMediaQuery} {
    width: 140px;
  }
`;

export const stickerTopStartCss = css`
  inset-inline-start: var(--sticker-position-offset, ${defaultStickerInsetPx}px);
  top: var(--sticker-position-offset, ${defaultStickerInsetPx}px);
`;

export const stickerTopEndCss = css`
  inset-inline-end: var(--sticker-position-offset, ${defaultStickerInsetPx}px);
  top: var(--sticker-position-offset, ${defaultStickerInsetPx}px);
`;

export const stickerBottomStartCss = css`
  bottom: var(--sticker-position-offset, ${defaultStickerInsetPx}px);
  inset-inline-start: var(--sticker-position-offset, ${defaultStickerInsetPx}px);
`;

export const stickerBottomEndCss = css`
  bottom: var(--sticker-position-offset, ${defaultStickerInsetPx}px);
  inset-inline-end: var(--sticker-position-offset, ${defaultStickerInsetPx}px);
`;

export const stickerRotationNegative15DegreesCss = css`
  transform: rotate(-15deg);
`;

export const stickerRotationPositive15DegreesCss = css`
  transform: rotate(15deg);
`;
